import { Box, Button, Flex, Input, useColorModeValue } from "@chakra-ui/react";
import React, { useState } from "react";
import Calendar from "react-calendar";

export const SheduleMeeting = ({ setDisplayScreen }) => {
  const [date, setDate] = useState(new Date());
  const bgColor = useColorModeValue("#fff", "#020b19");
  const calendarColor = useColorModeValue("#000", "#fff");
  const secondaryBgColor = useColorModeValue("#e6e6e6", "#50bb69");
  const secondaryBgColor2 = useColorModeValue("#fff", "transparent");

  const overrideStyle = `
  .react-calendar__tile--now:focus {
    background: #ffffff !important;
    color: #fff !important;
}
.react-calendar__tile--now,  .react-calendar__tile--now:hover{
    background: none !important;
}
.react-calendar__tile--active {
    background-color: ${secondaryBgColor} !important;
    color: #fff !important;
    border-radius: 50%;
    width: 40px;
    height: 50px;
}


.react-calendar__month-view__weekdays__weekday {
    background: ${secondaryBgColor2} !important;
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    border: 0px solid #DFDFDF !important;

}

.react-calendar__navigation button {
  font-size: 1.2rem;
  font-weight: 600;
  color: #3F4168
}

abbr[title] {
   font-weight: 500 !important;
    text-decoration: none !important;
}

.react-calendar__tile:disabled {
    background-color: none !important;
    opacity: .3 !important;
}

.react-calendar {
    color: ${calendarColor} !important;
    border: none;
    width: 100%;
    background: ${bgColor} !important;
}
.react-calendar button {
    color: ${calendarColor};
}
.react-calendar__tile:enabled:hover{
    background-color: transparent ;
       color: ${calendarColor};
}
.react-calendar__tile:enabled:focus{
   background-color: ${secondaryBgColor} !important;
       color: ${calendarColor} !important;
}

`;

  return (
    <Flex
      direction="column"
      height={"80vh"}
      align="center"
      justify="center"
      width="100%"
    >
      <Box
        width={["100%", "90%", "420px"]}
        bg={bgColor}
        padding="25px"
        borderRadius={"10px"}
      >
        <Flex mb={6} alignItems="center" justifyContent={"center"}>
          <Input
            py="25px"
            width="100%"
            shadow="md"
            placeholder="Meeting Title"
          />
        </Flex>
        <style>{overrideStyle}</style>

        <Calendar onChange={setDate} value={date} />
        <Box my="20px">
          <Input shadow={"md"} borderRadius="10px" width="200px" type="time" />
        </Box>
        <Box>
          <Button
            width="200px"
            bg="#50BB69"
            color={"#fff"}
            onClick={() => setDisplayScreen("create-meeting")}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Flex>
  );
};
